import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=94d72012&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d72012",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/build_997aa59e/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('94d72012')) {
      api.createRecord('94d72012', component.options)
    } else {
      api.reload('94d72012', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=94d72012&scoped=true", function () {
      api.rerender('94d72012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/investments/cash-request-manager/Index.vue"
export default component.exports